<template>
  <div class="">
    <Card :Style="'my-1'" back>
      <template v-slot:header>
        <h5 class="">عوامل حقوق</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-hover mt-2" :key="Render">
            <thead>
              <tr>
                <th scope="col" style="width: 2% !important">ردیف</th>
                <th scope="col" style="width: 38% !important">عنوان</th>
                <th scope="col" style="width: 20% !important">مشمول بیمه</th>
                <th scope="col" style="width: 20% !important">مشمول مالیات</th>
                <th scope="col" style="width: 20% !important">مشمول اضافه کار</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" v-for="(item, key, index) in Rows" :key="key">
                <td>{{ index + 1 }}</td>
                <td>{{ Translate(key) }}</td>
                <td>
                  <div class="text-center">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input required InputText" :id="'Bime' + key + index" v-model="AllRows.SumMashmolBime[key]" />
                      <label class="custom-control-label" :for="'Bime' + key + index"> </label>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="text-center">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input required InputText" :id="'Maliiyat' + key + index" v-model="AllRows.SumMashmolMaliat[key]" />
                      <label class="custom-control-label" :for="'Maliiyat' + key + index"> </label>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="text-center" v-if="!NotAddWork.includes(key)">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input required InputText" :id="'Work' + key + index" v-model="AllRows.AddWork[key]" />
                      <label class="custom-control-label" :for="'Work' + key + index"> </label>
                    </div>
                  </div>
                  <div class="" v-else>
                    <h6 class="text-warning">ندارد</h6>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="" >
          <button type="button" class="btn btn-warning" @click="UpdateData"><i class="fad fa-pen ml-2"></i> اعمال اصلاحیات </button>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card },
  data() {
    return {
      Rows: [],
      AllRows: [],
      NotAddWork: ['AddWork', 'Rewards', 'Eidi', 'YearSanavat', 'Misson', 'HagheTaahol'],
      Dictionary: {
        SalaryBasic: 'حقوق پایه',
        Child: 'حق اولاد',
        Home: ' حق مسکن ',
        AddWork: ' اضافه کاری  ',
        Bone: ' حق بن ',
        Sanavat: ' پایه سنوات ',
        Skill: ' مهارت ',
        Responsibility: ' حق مسئولیت ',
        Education: ' حق تحصیلات ',
        Amazing: '  فوق العاده ',
        HageJazb: ' حق جذب ',
        HageShift: ' حق شیفت ',
        HardWork: ' سختی کار ',
        Food: ' حق غذا ',
        Cashier: ' صندوق دار ',
        Transportation: ' ایاب و ذهاب ',
        OtherBenefits: ' سایر مزایا ',
        Rewards: ' پاداش ',
        Eidi: ' عیدی ',
        YearSanavat: ' سنوات پایان سال ',
        Misson: ' حق ماموریت ',
        HagheTaahol: ' حق تاهل ',
      },
      Render:0
    }
  },
  methods: {
    GetListSettings() {
      let DataAxiosGetData = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'FormulaSalary',
        Token: this.$session.get('Token'),
        From: 'Header',
      }
        DataAxiosGetData.ArryfildValue['Id'] = this.tblWorkShopId
      this.$GetData_Header(DataAxiosGetData).then((data) => {
        if (data.IsSuccess) {
          this.AllRows = data.Data
          this.Rows = data.Data.SumMashmolBime
        } else {
          alert(data.Message)
        }
      })
    },
    Translate(key) {
      return this.Dictionary[key]
    },
    UpdateData(){
      this.$PostData_new('put', 'FormulaSalary', this.AllRows)
        .then((res) => {
          if (res.IsSuccess) {
            this.$mySweetDefaultTost('عملیات موفق', res.Message, 'success', 2000)
            this.$emit('Result', res.IsSuccess)
            this.GetListSettings()
            this.Render++
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', res.Message, 'error', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
          console.error(err)
        })
    }
  },
  props: ['tblWorkShopId'],
  created() {
    this.GetListSettings()
  },
}
</script>
<style scoped>
tr {
  color: var(--sidebar-color-item) !important;
}
table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}
td {
  border-color: var(--table-border-color) !important;
}
th {
  font-weight: normal;
  text-align: center;
  font-size: 12px;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}
thead {
  border-color: var(--table-border-color) !important;
}
tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}
tbody {
  border: rgb(255, 255, 255) !important;
}
</style>
